<template>
    <div>
        <div class="sel-vats bg-pale-yellow mb-1">
            <div class="container">
                <span>{{ displayTitle }}</span>
                &nbsp;
                <select
                    data-element="select-vats"
                    v-model="anchor"
                    @change="change"
                >
                    <option
                        :value="item.anchor"
                        :key="item.anchor"
                        v-for="item in items"
                    >
                        {{ item.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="mb-2">
            <div class="note warn">
                <i class="ui ui-warn note-icon"></i>
                <p>Уважаемый клиент! Обратите внимание на изменение процедуры активации номера: необходимо подписать договор и/или бланк заказа к договору.</p>
                <p>Для подписания необходимо обратиться в клиентскую службу по номеру <a href="tel:+78005555424,4821">+7&nbsp;(800)&nbsp;555-54-24</a> доб.&nbsp;4821 или к вашему персональному менеджеру.</p>
                <button class="ui-close sm"></button>
            </div>
        </div>
    </div>
</template>

<script>
import ModelVats from '../models/vats.js';

export default {
    name: "VatsSelect",
    props: {
        items: {
            type: Array
        },
        currentVats: {
            type: ModelVats
        },
        vatsSelectTitle: {
            type: String
        }
    },
    data () {
        return {
            anchor: null
        }
    },
    computed: {
        displayTitle () {
            return this.vatsSelectTitle ? this.vatsSelectTitle : 'Выберите Виртуальную АТС, к которой будут подключены номера'
        }
    },
    mounted () {
        if (this.currentVats) {
            this.anchor = this.currentVats.anchor
        }
    },
    methods: {
        change () {
            let vats = this.items.find(item => item.anchor === this.anchor);
            if (vats) {
                this.$emit('change', vats)
            }
        }
    }
}
</script>

<style scoped>

</style>